import { useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../config';
import { useNavigate } from 'react-router-dom';
import { showError, showSuccess } from '../utils/alerts';
import '../styles/pages/CompanySettingsPage.css';

const CompanySettingsPage = ({ token, id_company, setCompany }) => {
  const [form, setForm] = useState({
    name: '',
    rut: '',
    address: '',
    rep_legal: '',
    rut_representante: '',
    comuna: '',
    ciudad: '',
    email: '',
    phone: '',
    area: '',
    clave_sii: '',
    conciliacion_bancaria: '',
    recursos_humanos: ''
  });
  const [loading, setLoading] = useState(true);
  const [phoneError, setPhoneError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCompany = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/api/company/companies/${id_company}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setForm({ ...response.data, clave_sii: '' });
      } catch (error) {
        console.error('Error al obtener datos de la empresa:', error);
        showError('No se pudieron cargar los datos de la empresa');
      } finally {
        setLoading(false);
      }
    };
    fetchCompany();
  }, [id_company, token]);

  const validatePhone = (value) => {
    if (!value.startsWith('56')) return 'El teléfono debe comenzar con 56 (ej: 56912345678)';
    if (value.length !== 11) return 'El teléfono debe tener exactamente 11 dígitos (ej: 56912345678)';
    if (!/^\d+$/.test(value)) return 'El teléfono debe contener solo números';
    return '';
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'phone') {
      setPhoneError(validatePhone(value));
    }
    setForm({ ...form, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const error = validatePhone(form.phone);
    if (error) {
      setPhoneError(error);
      return;
    }
    try {
      const response = await axios.put(`${API_BASE_URL}/api/company/companies/${id_company}`, form, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setCompany({
        id_company: response.data.id_company,
        name: response.data.name,
        conciliacion_bancaria: response.data.conciliacion_bancaria,
        recursos_humanos: response.data.recursos_humanos
      });
      showSuccess('Datos de la empresa actualizados');
      navigate('/dashboard');
    } catch (error) {
      console.error('Error al actualizar empresa:', error);
      showError(error.response?.data?.message || 'Error al actualizar empresa');
    }
  };

  if (loading) {
    return <div className="company-settings-container"><p>Cargando datos de la empresa...</p></div>;
  }

  return (
    <div className="company-settings-container">
      <h1>Configuración de la Empresa</h1>
      <form className="company-settings-form" onSubmit={handleSubmit}>
        <input name="name" value={form.name} onChange={handleChange} placeholder="Nombre de la Empresa" required />
        <input name="rut" value={form.rut} disabled title="El RUT de la empresa no se puede modificar" />
        <input name="address" value={form.address} onChange={handleChange} placeholder="Dirección" required />
        <input name="comuna" value={form.comuna} onChange={handleChange} placeholder="Comuna" required />
        <input name="ciudad" value={form.ciudad} onChange={handleChange} placeholder="Ciudad" required />
        <input name="rep_legal" value={form.rep_legal} onChange={handleChange} placeholder="Nombre Representante Legal" required />
        <input name="rut_representante" value={form.rut_representante} onChange={handleChange} placeholder="RUT Representante Legal" required />
        <input name="email" type="email" value={form.email} onChange={handleChange} placeholder="Email" required />
        <input
          name="phone"
          value={form.phone}
          onChange={handleChange}
          placeholder="Teléfono (ej: 56912345678)"
          maxLength={11}
          required
        />
        {phoneError && <p className="company-settings-field-error">{phoneError}</p>}
        <input
          name="clave_sii"
          type="password"
          value={form.clave_sii}
          onChange={handleChange}
          placeholder="Nueva Clave SII (dejar en blanco para no cambiarla)"
        />
        <select
          name="conciliacion_bancaria"
          value={String(form.conciliacion_bancaria)}
          onChange={(e) => setForm({ ...form, conciliacion_bancaria: e.target.value })}
          required>
          <option value="" disabled>¿Conciliación Bancaria?</option>
          <option value="true">Sí</option>
          <option value="false">No</option>
        </select>
        <select
          name="recursos_humanos"
          value={String(form.recursos_humanos)}
          onChange={(e) => setForm({ ...form, recursos_humanos: e.target.value })}
          required>
          <option value="" disabled>¿Recursos Humanos?</option>
          <option value="true">Sí</option>
          <option value="false">No</option>
        </select>
        <select name="area" value={form.area} disabled title="El tipo de empresa no se puede modificar">
          <option value={form.area}>{form.area}</option>
        </select>
        <button type="submit">Guardar cambios</button>
      </form>
      <p className="company-settings-hint">
        El <strong>RUT</strong> y el <strong>tipo de empresa</strong> no se pueden modificar una vez creada la empresa.
      </p>
    </div>
  );
};

export default CompanySettingsPage;
